import React from 'react';

import useMegaMenu from 'hooks/useMegaMenu';

import Login from '../Login';
import NavBar from '../NavBar';
import SideNavSection from '../SideNav';
import { ComponentProps } from './interfaces';
import * as Styled from './styled';

const Header: React.FC<ComponentProps> = ({
  client_id = '',
  redirect_uri = '',
  loginUrl = '',
  authStore,
  linkTarget,
  showLogin = false,
  showSideNav = false,
  navItems = [],
  fetchItemsFromAPI = false
}) => {
  const { items: megaMenuItems } = useMegaMenu(fetchItemsFromAPI);
  const menuItems = megaMenuItems ?? navItems;

  return (
    <Styled.Wrapper role='banner'>
      {showSideNav && (
        <Styled.MobileNavigation>
          <SideNavSection
            loginUrl={loginUrl}
            client_id={client_id}
            redirect_uri={redirect_uri}
            linkTarget={linkTarget}
            authStore={authStore}
            items={menuItems}
          />
        </Styled.MobileNavigation>
      )}
      <Styled.LogoWrapper text='The new place to go for government services' />
      <Styled.DesktopNavigation>
        <Styled.NavBarWrapper>{navItems && <NavBar items={menuItems} />}</Styled.NavBarWrapper>
        <Styled.LoginButton>
          {showLogin && (
            <Login
              client_id={client_id}
              loginUrl={loginUrl}
              redirect_uri={redirect_uri}
              linkTarget={linkTarget}
              authStore={authStore}
            />
          )}
        </Styled.LoginButton>
      </Styled.DesktopNavigation>
    </Styled.Wrapper>
  );
};

export default Header;
